import Link from 'next/link';
import PanelistaLogo from '../../public/images/panelistaLogo.svg';

const PanelistaHeaderLink = () => {
  return (
    <Link href="/">
      <PanelistaLogo className="relative w-[120px] block [&_g]:fill-[--panelista-color]" />
    </Link>
  );
};

export default PanelistaHeaderLink;
